import { phoneFormat } from 'utils';
import Checkbox from '@mui/material/Checkbox';
import translating from '../../translate.json';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import './style.scss';

const EmailSms = ({ email, mobile, handleSetType }) => {
  const types = ['eMail', 'Sms'];
  const [currentType, setType] = useState(['eMail', 'Sms']);

  useEffect(() => {
    if (currentType) handleSetType(currentType);
  }, [currentType]);

  const handleChangeType = (newtype) => {
    let copyTypes = JSON.parse(JSON.stringify(currentType));
    const index = copyTypes.indexOf(newtype);
    if (index > -1) {
      copyTypes.splice(index, 1);
      setType(copyTypes);
    } else {
      copyTypes.push(newtype);
      setType(copyTypes);
    }
  };

  return (
    <div className="email-sms-target-type">
      {types?.map((type, key) => {
        if ((key === 1 && mobile) || (key === 0 && email))
          return (
            <div className="targrt-type" key={key}>
              <div className="wrapper-cb">
                <Checkbox
                  defaultChecked
                  checked={currentType.indexOf(type) > -1}
                  onChange={() => handleChangeType(type)}
                />
                <div>{translating[type.toLowerCase()]}</div>
              </div>
              <div className="target-value">
                {key === 1 ? phoneFormat(mobile) : email}
              </div>
            </div>
          );
      })}
    </div>
  );
};

export default EmailSms;

EmailSms.propTypes = {
  email: PropTypes.string,
  mobile: PropTypes.string,
  handleSetType: PropTypes.func
};
